// src/modules/requerimiento/views/adicion/AdicionCampo.jsx
import React from "react";
import { Box } from "@mui/material";
import AdicionProgramacion from "./Programacion";
import AdicionTrabajoCampo from "./TrabajoCampo";

/**
 * Adición de equipo nuevo sin etapa de Programación, igual que en la app Android: arriba la
 * tarjeta "Equipos a instalar" (buscar y asignar equipos, lo que antes era Programación) y abajo
 * el Trabajo de campo (cada equipo con "Instalar en vehículo", quitar los pendientes y finalizar).
 * La vinculación adicional no pasa por acá: sigue con su Programación (ver views/index.js).
 */
export default function AdicionCampo(props) {
  return (
    <Box>
      <AdicionProgramacion {...props} embebido />
      <AdicionTrabajoCampo {...props} permitirQuitar />
    </Box>
  );
}
